import { enableProdMode } from "@angular/core";
import "hammerjs";

import { bootstrapApplication } from "@angular/platform-browser";
import { mergeApplicationConfig } from "@angular/core";
import { AppComponent } from "./app/app.component";
import { appConfig, firebaseProviders } from "./app/app.config";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

// Firebase is browser-only (see app.config.ts) — added here, never on the server. (#52)
const browserConfig = mergeApplicationConfig(appConfig, { providers: firebaseProviders });

bootstrapApplication(AppComponent, browserConfig)
  .then(() => {
    if ("serviceWorker" in navigator) {
      if (environment.enableServiceWorker) {
        navigator.serviceWorker.register("ngsw-worker-mod.js");
      } else {
        // staging/dev: no SW. Actively unregister any stale worker + purge its
        // caches so browsers poisoned by an old build's cached chunks self-heal
        // on the next load (was causing white screens after redeploys).
        navigator.serviceWorker
          .getRegistrations()
          .then(regs => regs.forEach(r => r.unregister()));
        if ("caches" in window) {
          caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
        }
      }
    }
  })
  .catch(err => console.log(err));
